import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';
/**
 * Chart.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class PartnerUserModel extends BaseAPIModel {
    fields() {
        return {
            uuid: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, partnerId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][Partner] organizationId is mandatory');
        }
        if (!partnerId) {
            throw new ArgumentError('[Model][Partner] partnerId is mandatory');
        }
        return `/ticket/organizations/${organizationId}/partners/${partnerId}/users`;
    }

    resend_mail({ organizationId, mail_body, mail_subject } = {}) {
        let data = { mail_body, mail_subject };
        if (!mail_body) {
            delete data.mail_body;
        }

        if (!mail_subject) {
            delete data.mail_subject;
        }

        let url = `${this.constructor.listUrl({ organizationId, partnerId: this.partner })}/${this.pk}/send-mail`;
        return BaseAPIModel.fetcher.post(url, {
            data
        });
    }
}
